import React, { Fragment } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import HeaderCard from "../../Common/Component/HeaderCard";
import DataTableComponent from "./DataTableComponent";

const DataTables = ({
  parent,
  title,
  mainTitle,
  headerCardTitle,
  initialData = [],
  columns = [],
  action,
  meta,
  onPageChange,
  onPerPageChange,
  onSort,
  sortServer,
  defaultSortFieldId,
  defaultSortAsc,
  center
}) => {
  const showBreadcrumbs = !!(parent || title || mainTitle);
  const showHeaderCard = !!(headerCardTitle || action);

  return (
    <Fragment>
      {showBreadcrumbs && (
        <Breadcrumbs parent={parent} title={title} mainTitle={mainTitle} />
      )}
      <Container fluid>
        <Row>
          <Col sm="12">
            {showHeaderCard && (
              <Card>
                <HeaderCard title={headerCardTitle} action={action} />
                <CardBody>
                  <DataTableComponent
                    data={initialData}
                    columns={columns}
                    meta={meta}
                    onPageChange={onPageChange}
                    onPerPageChange={onPerPageChange}
                    onSort={onSort}
                    sortServer={sortServer}
                    defaultSortFieldId={defaultSortFieldId}
                    defaultSortAsc={defaultSortAsc}
                    center={center}
                  />
                </CardBody>
              </Card>
            )}
            {!showHeaderCard && (
              <DataTableComponent
                data={initialData}
                columns={columns}
                meta={meta}
                onPageChange={onPageChange}
                onPerPageChange={onPerPageChange}
                onSort={onSort}
                sortServer={sortServer}
                defaultSortFieldId={defaultSortFieldId}
                defaultSortAsc={defaultSortAsc}
                center={center}
              />
            )}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default DataTables;